export type { OpenChatSideBar, CloseChatSideBar } from './chat-details';
export {
	OPEN_CHAT_SIDE_BAR,
	CLOSE_CHAT_SIDE_BAR,
	openChatSideBar,
	closeChatSideBar,
} from './chat-details';
